@use 'sass:color';
@use "../../scss/util";

/*•••••••••••••• FLEX PROPS ••••••••••••••*/
.navFlexWrapper { 
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1600px;
  margin: 0 auto 50px;
  padding: 0 20px;
}

.navDesktop {display: none }
.navMobile {display: block }

.navDesktop { 
  @include util.mq(util.$lg) { 
    display: flex;
    align-items: center;
    gap: 20px;
  }
}

.navMobile { @include util.mq(util.$lg) { display: none }}

/*•••••••••••••• HOME LOGO LINK ••••••••••••••*/
.logoBox { margin-right: auto }
.logoHomeLink { display: block }
.logo {
  max-width: 250px;
  height: auto;
}

/*•••••••••••••• MM TRIGGER ••••••••••••••*/
.mobileMenuTrigger {
  @include util.button(util.$eGreen, white);
  padding: 15px;
  cursor: pointer;
  transition: none;

  @include util.mq(util.$lg) { display: none }
}

.mmImage {
  width: 22px;
  height: auto;
  display: block;
  margin: 0 auto;
}

/*•••••••••••••• Mobile Menu ••••••••••••••*/
.closeMMBox { padding: 20px }
.closeMM {
  background-color: util.$eBlueDark;
  color: white;
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 0;
  border-radius: 100%;
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
  position: relative;

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1;
  }
}

.navMobile, .navMobileClosed {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  right: 0;
  bottom: 0;
  background: util.$eGold;
  z-index: 1000;
  padding: 0;
  margin: 0;
  list-style-type: none;
  transition: left .3s ease-in-out;
  overflow: scroll;

  li { display: block; margin-bottom: 20px; }
}

.navMobile { left: 0% }
.navMobileClosed { left: 100% }

.LinkMobile {
  display: block;
  background: none;
  border: 0;
  text-align: center;
  width: 100%;
  text-decoration: none;
  color: util.$eBlueDark;
  font-size: 36px;
  font-weight: 500;
  padding: 20px;
  line-height: 1;
  cursor: pointer;

  &:active {
    background-color: white;
  }
}

/*•••••••••••••• DESKTOP Menu ••••••••••••••*/

.navDesktop {
    list-style-type: none;
    padding: 0;
    margin: 0;


    .navDesktopLink {
      @include util.button(white, white);
      background: rgba(white, 0%);
      min-width: 100px;
      font-weight: 100;
      cursor: pointer;

      &:hover {
        background: rgba(white, 100%);
        color: util.$eBlueDark;
      }

      &Highlight {
        background: util.$eGold;
        color: util.$eBlueDark;
        font-weight: 600;

        &:hover {
          background: color.scale(util.$eGold, $lightness: -20%);
        }
      }
    }
  }